// extracted by mini-css-extract-plugin
export default {"container":"mainAttractionDetail_container__Tsc8e","wrapper":"mainAttractionDetail_wrapper__MacZ0"};